import React from 'react';
import PropTypes from 'prop-types';
import SMSplitViewMixin from 'components/mixins/SMSplitViewMixin';
import SMConst from 'lib/SMConst';
import SMRoomHelper from 'components/helpers/SMRoomHelper';
import SMErrorHelper from 'components/helpers/SMErrorHelper';
import SMEditMenuTableRow from 'components/dashboard/form/SMEditMenuTableRow';
import SMFormTextFieldWithError from 'components/dashboard/form/SMFormTextFieldWithError';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import reactMixin from 'react-mixin';

class SMORoomEditMenuView extends React.Component {

  componentDidMount() {
    window.addEventListener('resize', this.editViewSizeToFit.bind(this), false);
    this.editViewSizeToFit();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.editViewSizeToFit.bind(this), false);
  }

  componentDidUpdate(prevProps, prevState) {
    window.addEventListener('resize', this.editViewSizeToFit.bind(this), false);
    this.editViewSizeToFit();
  }

  editViewSizeToFit(e) {
    let $navigationTable = $(this.refs.navigationTable),
        $navigationTableFooter = $(this.refs.navigationTableFooter);

    $navigationTable.outerHeight(this.navigationTableHeight() - $navigationTableFooter.outerHeight());
  }

  getErrorFieldName(name, planIndex) {
    if (planIndex >= 0) {
      return 'plans/' + planIndex + '/' + name;
    } else {
      return name;
    }
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  actionButtonDidClick(status, label, e) {
    e.preventDefault();

    if (
      status !== SMConst.Visibility.Hidden ||
      window.confirm(I18n.t("dashboard.notice_000011"))
    ) {
      this.trackPageEvent(label);

      if(this.props.delegate && typeof this.props.delegate.actionButtonDidClick === 'function') {
        this.props.delegate.actionButtonDidClick(status, e);
      }
    }
  }

  isCheckedBasic() {
    let requiredFields = ['area'];
    let validationFields = ['name', 'area'];
    let zeroAllowedRequiredFields = [];

    if (SMRoomHelper.isAllowedRentType(this.props.room, SMConst.RentType.DayTime)) {
      requiredFields = requiredFields.concat(['capacity', 'event_type', 'business_end_hour']);
      zeroAllowedRequiredFields = zeroAllowedRequiredFields.concat(['business_start_hour']);
      validationFields = validationFields.concat(['capacity', 'event_type', 'business_start_hour', 'business_end_hour']);
    }

    if (SMRoomHelper.isAllowedRentType(this.props.room, SMConst.RentType.Stay)) {
      requiredFields = requiredFields.concat(['stay_certification', 'stay_capacity', 'stay_checkin_end_hour', 'stay_checkin_end_hour', 'stay_checkout_hour']);
      zeroAllowedRequiredFields = zeroAllowedRequiredFields.concat(['stay_checkin_start_hour']);
      validationFields = validationFields.concat(['stay_capacity', 'stay_checkin_start_hour', 'stay_checkin_end_hour', 'stay_checkout_hour']);
    }

    if (SMErrorHelper.hasEmptyRequiredFields(this.props.room, requiredFields) ||
        SMErrorHelper.hasEmptyNotZeroRequiredFields(this.props.room, zeroAllowedRequiredFields) ||
        SMErrorHelper.hasValidationErrorFields(this.props.errors, 'Room', validationFields)) {
      return SMConst.AccessoryType.UnMarked;
    } else {
      return SMConst.AccessoryType.Checked;
    }
  }

  isCheckedDescription() {
    if (SMErrorHelper.hasEmptyRequiredFields(this.props.room, ['description']) ||
        SMErrorHelper.hasValidationErrorFields(this.props.errors, 'Room', ['food_description', 'trash_description', 'description'])) {
      return SMConst.AccessoryType.UnMarked;
    } else {
      return SMConst.AccessoryType.Checked;
    }
  }

  isCheckedMedia() {
    if (SMErrorHelper.hasEmptyRequiredFields(this.props.room, ['attachments'])) {
      return SMConst.AccessoryType.UnMarked;
    } else {
      return SMConst.AccessoryType.Checked;
    }
  }

  isCheckedPlan(plan, planIndex) {
    let requiredFields = [];
    let validationFields = [];
    let zeroAllowedRequiredFields = ['direct_reservation_accepted'];

    if (plan.rent_type == SMConst.RentType.DayTime) {
      validationFields = [
        'session_price',
        'min_required_session_hour',
        'hourly_price',
        'daily_price',
        'min_required_hour',
        'min_required_food_price',
        'has_daily_price',
        'has_hourly_price'
      ];
    } else if (plan.rent_type == SMConst.RentType.Stay) {
      validationFields = [
        'stay_price',
        'min_stay_days',
        'max_stay_days',
      ];
    }

    if (plan != this.props.room) {
      requiredFields.push('name', 'description');
      validationFields.push('name', 'description');
    }

    if (plan.rent_type == SMConst.RentType.DayTime) {
      if (plan.has_session_price) requiredFields.push('session_price', 'min_required_session_hour');
      if (plan.has_hourly_price) requiredFields.push('hourly_price');
      if (plan.has_daily_price) requiredFields.push('daily_price');
      if (!plan.has_session_price && !plan.has_daily_price && !plan.has_hourly_price) return SMConst.AccessoryType.UnMarked;
    }
    if (plan.has_min_required_hour) requiredFields.push('min_required_hour');
    if (plan.has_min_required_food_price) requiredFields.push('min_required_food_price');

    if (SMErrorHelper.hasEmptyRequiredFields(plan, requiredFields)) return SMConst.AccessoryType.UnMarked;
    if (SMErrorHelper.hasEmptyNotZeroRequiredFields(plan, zeroAllowedRequiredFields)) return SMConst.AccessoryType.UnMarked;
    let processedValidationFields = validationFields.map(function(field) { return this.getErrorFieldName(field, planIndex); }, this);
    if (SMErrorHelper.hasValidationErrorFields(this.props.errors, 'Room', processedValidationFields)) return SMConst.AccessoryType.UnMarked;

    return SMConst.AccessoryType.Checked;
  }

  isCheckedOption(name) {
    let validationFields = [];

    this.props.room.option_items.forEach(function(item, index) {
      validationFields.push(name + '/' + index + '/name');
      validationFields.push(name + '/' + index + '/description');
      validationFields.push(name + '/' + index + '/session_price');
    });

    if (SMErrorHelper.hasValidationErrorFields(this.props.errors, 'Room', validationFields)) {
      return SMConst.AccessoryType.UnMarked;
    } else {
      return SMConst.AccessoryType.Checked;
    }
  }

  renderActionButtons() {
    // 未入力
    if (!this.props.room.can_display) {
      return(
        <div ref="navigationTableFooter" className="dashboard-sidecol__buttonarea-bottom">
          <p className="dashboard-sidecol__buttonarea-title">必要な情報が<br />すべて入力されていません</p>
          <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)} className="button-gray dashboard-sidecol__buttonarea-button" onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od temporarily_save room_0')}>終了</a>
        </div>
      );
    }
    // 会場 非公開
    else if (!this.props.space.can_display){
      return (
        <div ref="navigationTableFooter" className="dashboard-sidecol__buttonarea-bottom">
          <p className="dashboard-sidecol__buttonarea-title">会場の登録が完了していません</p>
          <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)} className="button-gray dashboard-sidecol__buttonarea-button" onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od temporarily_save room_0')}>終了</a>
        </div>
      );
    }
    // 審査前 または 宿泊があり審査前
    else if (
      (this.props.owner.status == SMConst.OwnerStatus.Created) ||
        (this.props.room &&
         this.props.room.stay_certification_status != SMConst.StayCertificationStatus.Activated &&
           SMRoomHelper.isIncludeStayPlan(this.props.room))
    ) {
      return(
        <div ref="navigationTableFooter" className="dashboard-sidecol__buttonarea-bottom">
          <p className="dashboard-sidecol__buttonarea-title message-information">公開するのに必要な情報が<br />すべて入力されました</p>
          <p className="dashboard-sidecol__buttonarea-content">掲載審査へ進みましょう！</p>
          <a href={Routes.owner_dashboard_settings_review_path(this.props.owner.username)}
            className='dashboard-sidecol__buttonarea-button button-green mb10' onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od owner_review')}>掲載審査へ</a>
          <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)}
            className="button-gray dashboard-sidecol__buttonarea-button"
            onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od temporarily_save room_0')}>終了</a>
        </div>
      );
    }
    else {
      return(
        <div ref="navigationTableFooter" className="dashboard-sidecol__buttonarea-bottom">
          <p className="dashboard-sidecol__buttonarea-content">「公開して終了」クリックで公開されます</p>
          <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)} className='dashboard-sidecol__buttonarea-button button-green' onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od save visible_room_0')}>公開して終了</a>
          <p className="dashboard-sidecol__buttonarea-help"><a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)} className="link-hover-border" onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Hidden, 'od save hidden_room')}>非公開として終了</a></p>
        </div>
      );
    }
  }

  render() {
    let navigationTitles = [
      {name:"基本情報", id:'basic', rowIndex:0},
      {name:"スペースの紹介", id:'description', rowIndex:1},
      {name:"写真・動画", id:'media', rowIndex:2},
      {name:"プランと価格", id:'base_price_section', rowIndex:-1}
    ];
    let navigationRows = [];
    let rowType = SMConst.TableRowType.default;
    let accessoryType = SMConst.AccessoryType.None;
    let rowIndex = 0;

    navigationTitles.push({name:this.props.room.plan_name, id:'basic_plan', rowIndex:3});
    if (this.props.room.plans) {
      for (let i=0; i < this.props.room.plans.length; i++) {
        navigationTitles.push({name:this.props.room.plans[i].name, id:'plan-' + this.props.room.plans[i].id, plan: this.props.room.plans[i], planIndex: i, rowIndex:4+i});
      }
    }

    navigationTitles = navigationTitles.concat([
      {name:'オプション価格', id:'option_price_section', rowIndex: -2},
      {name:'設備・サービス', id:'option', rowIndex: 4+this.props.room.plans.length},
    ]);

    if (this.props.room.option_foods.length > 0) {
      navigationTitles.push({name:'飲食', id:'food', rowIndex: 5+this.props.room.plans.length});
    }

    for (let i = 0; i < navigationTitles.length; i++) {
      let isCurrent = this.props.selectedRowIndex == navigationTitles[i].rowIndex,
          title = navigationTitles[i];

      if (navigationTitles[i].id == 'basic') {
        rowType = SMConst.TableRowType.Default;
        accessoryType = this.isCheckedBasic();
      } else if (navigationTitles[i].id == 'description') {
        rowType = SMConst.TableRowType.Default;
        accessoryType = this.isCheckedDescription();
      } else if (navigationTitles[i].id == 'media') {
        rowType = SMConst.TableRowType.Default;
        accessoryType = this.isCheckedMedia();
      } else if (navigationTitles[i].id == 'availability') {
        rowType = SMConst.TableRowType.Default;
        accessoryType = SMConst.AccessoryType.Checked;
      } else if (navigationTitles[i].id == 'base_price_section') {
        rowType = SMConst.TableRowType.SectionWithAddButton;
      } else if (navigationTitles[i].id == 'option_price_section') {
        rowType = SMConst.TableRowType.Section;
      } else if (navigationTitles[i].id == 'basic_plan') {
        rowType = SMConst.TableRowType.Default;
        accessoryType = this.isCheckedPlan(this.props.room, -1);
      } else if (navigationTitles[i].id.search(/^plan-/) != -1) {
        rowType = SMConst.TableRowType.Default;
        accessoryType = this.isCheckedPlan(navigationTitles[i].plan, navigationTitles[i].planIndex);
      } else if (navigationTitles[i].id == 'option') {
        rowType = SMConst.TableRowType.Default;
        accessoryType = this.isCheckedOption('option_items');
      } else if (navigationTitles[i].id == 'food') {
        rowType = SMConst.TableRowType.Default;
        accessoryType = this.isCheckedOption('option_foods');
      } else {
        rowType = SMConst.TableRowType.Default;
      }

      navigationRows.push(<SMEditMenuTableRow key={navigationTitles[i].id}
        title={navigationTitles[i].name}
        delegate={this.props.delegate}
        rowType={rowType}
        accessoryType={accessoryType}
        rowIndex={navigationTitles[i].rowIndex}
        isCurrent={isCurrent} />);
    }

    if (this.props.action == 'new') {
      return(
        <div className="dashboard-sidecol fl">
          <h2 className="dashboard-title mt25 mb25 ml20 mr10">
          {I18n.t("dashboard.label_000085")}
          </h2>
          <div ref="navigationTable" className="js-scroller dashboard-sidecol__scrollarea">
            <ul>{navigationRows}</ul>
          </div>
          {this.renderActionButtons()}
        </div>
      );
    } else {
      return(
        <div className="dashboard-sidecol fl">
          <h2 className="dashboard-title mt25 mb25 ml20 mr10">
            <img src={this.props.room.attachments.length ? this.props.room.attachments[0].image : SMRailsBridge.assetPath.noImageSpace} className="dashboard-title__space-img" />
            {I18n.t("dashboard.label_000094")}
            <span className="dashboard-title__space-name">{this.props.room.name}</span>
          </h2>
          <div ref="navigationTable" className="js-scroller dashboard-sidecol__scrollarea">
            <ul>{navigationRows}</ul>
          </div>
          {this.renderActionButtons()}
        </div>
      );
    }
  }
}
SMORoomEditMenuView.propTypes = {
  owner: PropTypes.object.isRequired,
  space: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired,
  delegate: PropTypes.object.isRequired,
  selectedRowIndex: PropTypes.number.isRequired,
  action: PropTypes.string.isRequired,
};
reactMixin(SMORoomEditMenuView.prototype, SMSplitViewMixin);
export default SMORoomEditMenuView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/SMORoomEditMenuView.jsx